class LpDirectCheckout extends HTMLElement {
  connectedCallback() {
    this.querySelector('[data-checkout-button]')?.addEventListener('click', this.#checkout);
  }

  #checkout = async () => {
    const button = this.querySelector('[data-checkout-button]');
    const buttonText = this.querySelector('[data-button-text]');
    const error = this.querySelector('[data-error]');
    if (!(button instanceof HTMLButtonElement)) return;

    const quantityInput = document.querySelector('quantity-selector-component input[ref="quantityInput"]');
    const quantity = quantityInput instanceof HTMLInputElement ? Number(quantityInput.value) || 1 : 1;
    const variantId = this.dataset.variantId;

    if (!variantId) return;

    const originalText = buttonText?.textContent;
    button.disabled = true;
    if (buttonText) buttonText.textContent = this.dataset.redirectingText || 'Redirecting…';
    if (error) error.hidden = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
      });

      if (!response.ok) throw new Error('Could not add item to cart');

      window.location.href = '/checkout';
    } catch (_e) {
      button.disabled = false;
      if (buttonText && originalText) buttonText.textContent = originalText;
      if (error) {
        error.hidden = false;
        error.textContent = this.dataset.errorText || 'Something went wrong. Please try again.';
      }
    }
  };
}

if (!customElements.get('lp-direct-checkout')) {
  customElements.define('lp-direct-checkout', LpDirectCheckout);
}
